// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Scaffold from "../../bundles/Scaffold/Scaffold.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as AmountTableCell from "../../modules/TableCell/AmountTableCell.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query AnalyticsTopPerformingStaffPageQuery($filterBy: TopPerformingStaffsQueryFilter, $sortBy: TopPerformingStaffsQuerySort)  {\ntopPerformingStaffs(filterBy: $filterBy, sortBy: $sortBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nstaffName  \nshopName  \nmargin  \nmarginRate  \nmarkupRate  \nproductsSoldCount  \nrevenueExcludingTaxes  \nrevenueIncludingTaxes  \nsalesCount  \nsalesIndex  \nshoppingCartAverage  \n}\n\n}\n\ntotalCount  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.topPerformingStaffs;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    topPerformingStaffs: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            staffName: value$1.staffName,
            shopName: value$1.shopName,
            margin: value$1.margin,
            marginRate: value$1.marginRate,
            markupRate: value$1.markupRate,
            productsSoldCount: value$1.productsSoldCount,
            revenueExcludingTaxes: value$1.revenueExcludingTaxes,
            revenueIncludingTaxes: value$1.revenueIncludingTaxes,
            salesCount: value$1.salesCount,
            salesIndex: value$1.salesIndex,
            shoppingCartAverage: value$1.shoppingCartAverage
          }
        };
      }),
      totalCount: value$1.totalCount
    }
  };
}

function serialize(value) {
  let value$1 = value.topPerformingStaffs;
  let value$2 = value$1.totalCount;
  let value$3 = value$1.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shoppingCartAverage;
    let value$3 = value$1.salesIndex;
    let value$4 = value$1.salesCount;
    let value$5 = value$1.revenueIncludingTaxes;
    let value$6 = value$1.revenueExcludingTaxes;
    let value$7 = value$1.productsSoldCount;
    let value$8 = value$1.markupRate;
    let value$9 = value$1.marginRate;
    let value$10 = value$1.margin;
    let value$11 = value$1.shopName;
    let value$12 = value$1.staffName;
    let value$13 = value$1.__typename;
    let node = {
      __typename: value$13,
      staffName: value$12,
      shopName: value$11,
      margin: value$10,
      marginRate: value$9,
      markupRate: value$8,
      productsSoldCount: value$7,
      revenueExcludingTaxes: value$6,
      revenueIncludingTaxes: value$5,
      salesCount: value$4,
      salesIndex: value$3,
      shoppingCartAverage: value$2
    };
    let value$14 = value.__typename;
    return {
      __typename: value$14,
      node: node
    };
  });
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let topPerformingStaffs = {
    __typename: value$8,
    pageInfo: pageInfo,
    edges: edges,
    totalCount: value$2
  };
  return {
    topPerformingStaffs: topPerformingStaffs
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectTopPerformingStaffsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.startDate;
  let a$2 = inp.endDate;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    startDate: a$1 !== undefined ? a$1 : undefined,
    endDate: a$2 !== undefined ? a$2 : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  let a$1 = inp.sortBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectTopPerformingStaffsQueryFilter(a) : undefined,
    sortBy: a$1 !== undefined ? (
        a$1 === "SALES_COUNT" ? "SALES_COUNT" : (
            a$1 === "MARGIN" ? "MARGIN" : (
                a$1 === "REVENUE_EXCLUDING_TAXES" ? "REVENUE_EXCLUDING_TAXES" : (
                    a$1 === "PRODUCTS_SOLD_COUNT" ? "PRODUCTS_SOLD_COUNT" : (
                        a$1 === "MARGIN_RATE" ? "MARGIN_RATE" : (
                            a$1 === "SHOPPING_CART_AVERAGE" ? "SHOPPING_CART_AVERAGE" : (
                                a$1 === "MARKUP_RATE" ? "MARKUP_RATE" : (
                                    a$1 === "REVENUE_INCLUDING_TAXES" ? "REVENUE_INCLUDING_TAXES" : "SALES_INDEX"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      ) : undefined
  };
}

function makeVariables(filterBy, sortBy) {
  return {
    filterBy: filterBy,
    sortBy: sortBy
  };
}

function makeInputObjectTopPerformingStaffsQueryFilter(shopIds, startDate, endDate, param) {
  return {
    shopIds: shopIds,
    startDate: startDate,
    endDate: endDate
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined,
    sortBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectTopPerformingStaffsQueryFilter: serializeInputObjectTopPerformingStaffsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectTopPerformingStaffsQueryFilter: makeInputObjectTopPerformingStaffsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectTopPerformingStaffsQueryFilter: serializeInputObjectTopPerformingStaffsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectTopPerformingStaffsQueryFilter: makeInputObjectTopPerformingStaffsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

let values = [
  "Margin",
  "MarginRate",
  "MarkupRate",
  "ProductsSoldCount",
  "RevenueExcludingTaxes",
  "RevenueIncludingTaxes",
  "SalesCount",
  "SalesIndex",
  "ShoppingCartAverage"
];

function toLabel(value) {
  switch (value) {
    case "Margin" :
      return I18n.t("Margin");
    case "MarginRate" :
      return I18n.t("Margin rate");
    case "MarkupRate" :
      return I18n.t("Markup rate");
    case "ProductsSoldCount" :
      return I18n.t("Products sold");
    case "RevenueExcludingTaxes" :
      return I18n.t("Revenue excl. VAT");
    case "RevenueIncludingTaxes" :
      return I18n.t("Revenue incl. VAT");
    case "SalesCount" :
      return I18n.t("Sales");
    case "SalesIndex" :
      return I18n.t("Sales index");
    case "ShoppingCartAverage" :
      return I18n.t("Shopping cart average");
  }
}

function toRawString(value) {
  switch (value) {
    case "Margin" :
      return "MARGIN";
    case "MarginRate" :
      return "MARGIN_RATE";
    case "MarkupRate" :
      return "MARKUP_RATE";
    case "ProductsSoldCount" :
      return "PRODUCTS_SOLD_COUNT";
    case "RevenueExcludingTaxes" :
      return "REVENUE_EXCLUDING_TAXES";
    case "RevenueIncludingTaxes" :
      return "REVENUE_INCLUDING_TAXES";
    case "SalesCount" :
      return "SALES_COUNT";
    case "SalesIndex" :
      return "SALES_INDEX";
    case "ShoppingCartAverage" :
      return "SHOPPING_CART_AVERAGE";
  }
}

function toQueryVariableValue(value) {
  switch (value) {
    case "Margin" :
      return "MARGIN";
    case "MarginRate" :
      return "MARGIN_RATE";
    case "MarkupRate" :
      return "MARKUP_RATE";
    case "ProductsSoldCount" :
      return "PRODUCTS_SOLD_COUNT";
    case "RevenueExcludingTaxes" :
      return "REVENUE_EXCLUDING_TAXES";
    case "RevenueIncludingTaxes" :
      return "REVENUE_INCLUDING_TAXES";
    case "SalesCount" :
      return "SALES_COUNT";
    case "SalesIndex" :
      return "SALES_INDEX";
    case "ShoppingCartAverage" :
      return "SHOPPING_CART_AVERAGE";
  }
}

let SortBy = {
  values: values,
  toLabel: toLabel,
  toRawString: toRawString,
  toQueryVariableValue: toQueryVariableValue
};

function encoder(param) {
  let match = param.dateRange;
  return [
    param.shops.map(shop => shop.id),
    [
      match[0].getTime(),
      match[1].getTime()
    ]
  ];
}

function decoder(shops, param) {
  let dateRange = param[1];
  let selectedShops = Stdlib_Array.filterMap(param[0], shopId => shops.find(shop => shop.id === shopId));
  let startDate = dateRange[0];
  let endDate = dateRange[1];
  return {
    TAG: "Ok",
    _0: {
      shops: selectedShops.length !== 0 ? selectedShops : shops,
      dateRange: [
        new Date(startDate),
        new Date(endDate)
      ]
    }
  };
}

function useJsonCodec() {
  let shops = Auth.useShops();
  return JsonCodec.object2(encoder, arg => decoder(shops, arg), JsonCodec.field("shopIds", JsonCodec.array(JsonCodec.string)), JsonCodec.field("dateRange", JsonCodec.array(JsonCodec.float)));
}

let Filters = {
  encoder: encoder,
  decoder: decoder,
  useJsonCodec: useJsonCodec
};

function fromQueryDataEdge(param) {
  let node = param.node;
  return {
    margin: I18n.currencyFormat(undefined, "EUR", undefined, undefined, node.margin),
    marginRate: I18n.percentFormat(undefined, 2, 2, node.marginRate / 100),
    markupRate: I18n.percentFormat(undefined, 2, 2, node.markupRate / 100),
    productsSoldCount: node.productsSoldCount.toString(),
    revenueExcludingTaxes: node.revenueExcludingTaxes,
    revenueIncludingTaxes: node.revenueIncludingTaxes,
    salesCount: node.salesCount.toString(),
    salesIndex: node.salesIndex.toString(),
    shoppingCartAverage: I18n.currencyFormat(undefined, "EUR", undefined, undefined, node.shoppingCartAverage),
    staffName: node.staffName,
    shopName: node.shopName
  };
}

let Row = {
  fromQueryDataEdge: fromQueryDataEdge
};

function makeQueryVariables(defaultQueryVariables, connectionArguments, search, filterBy, param) {
  return {
    filterBy: filterBy,
    sortBy: defaultQueryVariables.sortBy
  };
}

function makeQueryVariablesFilterBy(param) {
  let match = param.dateRange;
  return {
    shopIds: {
      _in: param.shops.map(shop => shop.id)
    },
    startDate: Scalar.Datetime.serialize(match[0]),
    endDate: Scalar.Datetime.serialize(match[1])
  };
}

function totalCountFromQueryData(param) {
  return param.topPerformingStaffs.totalCount;
}

function cursorsFromQueryData(param) {
  let topPerformingStaff = param.topPerformingStaffs;
  return [
    topPerformingStaff.pageInfo.startCursor,
    topPerformingStaff.pageInfo.endCursor
  ];
}

function rowsFromQueryDataAndState(param, param$1) {
  let currentPage = param$1.currentPage;
  return param.topPerformingStaffs.edges.slice((currentPage - 1 | 0) * Scaffold.edgesPerPage | 0, currentPage * Scaffold.edgesPerPage | 0).map(fromQueryDataEdge);
}

function keyExtractor(param) {
  return param.staffName;
}

let Scaffolded = Scaffold.Make({
  useFiltersJsonCodec: useJsonCodec,
  QueryInner: Query_inner,
  useQuery: use,
  makeQueryVariables: makeQueryVariables,
  makeQueryVariablesFilterBy: makeQueryVariablesFilterBy,
  cursorsFromQueryData: cursorsFromQueryData,
  totalCountFromQueryData: totalCountFromQueryData,
  rowsFromQueryDataAndState: rowsFromQueryDataAndState,
  keyExtractor: keyExtractor
});

let scaffoldedColumns = [
  {
    name: I18n.t("Seller"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 150
      },
      width: {
        NAME: "fr",
        VAL: 3.5
      },
      margin: "xlarge",
      sticky: true
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.staffName,
      weight: "semibold"
    })
  },
  {
    name: I18n.t("Shop"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 200
      },
      width: {
        NAME: "pct",
        VAL: 20
      },
      margin: "small"
    },
    render: param => JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(Stack.make, {
        children: JsxRuntime.jsx(TextStyle.make, {
          children: param.shopName
        })
      }),
      align: "center"
    })
  },
  {
    name: I18n.t("Revenue exc. VAT/inct. VAT"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 130
      },
      width: {
        NAME: "fr",
        VAL: 2
      }
    },
    render: param => JsxRuntime.jsx(AmountTableCell.make, {
      value: param.revenueExcludingTaxes,
      secondaryValue: param.revenueIncludingTaxes
    })
  },
  {
    name: I18n.t("Margin"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 130
      },
      width: {
        NAME: "fr",
        VAL: 1.5
      }
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.margin,
      weight: "semibold"
    })
  },
  {
    name: I18n.t("Margin/Markup rt"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 100
      },
      width: {
        NAME: "fr",
        VAL: 2.5
      }
    },
    render: param => JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(TextStyle.make, {
          children: param.marginRate,
          weight: "semibold"
        }),
        JsxRuntime.jsx(TextStyle.make, {
          children: param.markupRate,
          variation: "normal",
          size: "xxsmall"
        })
      ],
      space: "xxsmall"
    })
  },
  {
    name: I18n.t("Shopping cart average"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 100
      },
      margin: "small",
      alignX: "flexEnd"
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.shoppingCartAverage
    })
  },
  {
    name: I18n.t("Sales"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 100
      },
      width: {
        NAME: "px",
        VAL: 130
      },
      alignX: "center"
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.salesCount,
      weight: "semibold"
    })
  },
  {
    name: I18n.t("Sales index"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 85
      },
      width: {
        NAME: "px",
        VAL: 130
      },
      alignX: "center"
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.salesIndex,
      weight: "semibold"
    })
  },
  {
    name: I18n.t("Products sold"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 80
      },
      width: {
        NAME: "px",
        VAL: 130
      },
      alignX: "center"
    },
    render: param => JsxRuntime.jsx(TextStyle.make, {
      children: param.productsSoldCount,
      weight: "semibold"
    })
  }
];

let now = new Date();

let initialDateRange_0 = DateHelpers.startOfDay(now);

let initialDateRange_1 = DateHelpers.endOfDay(now);

let initialDateRange = [
  initialDateRange_0,
  initialDateRange_1
];

function AnalyticsTopPerformingStaffsPage(props) {
  let scope = Auth.useScope();
  let organisationAccount;
  organisationAccount = scope.TAG === "Organisation";
  let match;
  if (scope.TAG === "Organisation") {
    let shop = scope.activeShop;
    if (shop !== undefined) {
      match = [
        shop,
        scope.shops
      ];
    } else {
      let shops = scope.shops;
      match = [
        shops[0],
        shops
      ];
    }
  } else {
    let shop$1 = scope._0;
    match = [
      shop$1,
      [shop$1]
    ];
  }
  let allShops = match[1];
  let initialState = Scaffolded.makeInitialState({
    shops: allShops,
    dateRange: initialDateRange
  });
  let match$1 = Scaffolded.use(() => initialState);
  let dispatch = match$1[1];
  let state = match$1[0];
  let match$2 = React.useState(() => "RevenueExcludingTaxes");
  let setSortBy = match$2[1];
  let sortBy = match$2[0];
  let defaultQueryVariables_sortBy = toQueryVariableValue(sortBy);
  let defaultQueryVariables = {
    filterBy: undefined,
    sortBy: defaultQueryVariables_sortBy
  };
  let tmp;
  if (organisationAccount) {
    let match$3 = state.filters.shops.length;
    tmp = JsxRuntime.jsx(Auth.SelectShopFilter.make, {
      value: match$3 !== 1 ? undefined : match[0],
      onChange: maybeShop => {
        let selectedShop = maybeShop !== undefined ? [maybeShop] : allShops;
        dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shops: selectedShop,
            dateRange: prev.dateRange
          })
        });
      }
    });
  } else {
    tmp = null;
  }
  let items = values.map(value => ({
    TAG: "Option",
    key: toRawString(value),
    label: toLabel(value),
    value: value
  }));
  let filters = JsxRuntime.jsxs(Inline.make, {
    children: [
      tmp,
      organisationAccount ? JsxRuntime.jsx(CanarySeparator.make, {}) : null,
      JsxRuntime.jsx(Select.make, {
        label: I18n.t("Sorting"),
        preset: "filter",
        sections: [{
            items: items
          }],
        value: {
          TAG: "Single",
          _0: sortBy
        },
        onChange: change => {
          if (change.TAG !== "Single") {
            return;
          }
          let value = change._0;
          setSortBy(param => Stdlib_Option.getExn(value, undefined));
        }
      }),
      JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.dateRange,
        placeholder: I18n.t("Select a period"),
        hideResetButton: true,
        onChange: dateRange => {
          let dateRange$1 = Stdlib_Option.getOr(dateRange, initialDateRange);
          dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shops: prev.shops,
              dateRange: dateRange$1
            })
          });
        },
        triggerLabelDisplay: "showPreset"
      })
    ],
    space: "small"
  });
  let emptyState = JsxRuntime.jsx(EmptyState.make, {
    illustration: Illustration.noResultFound,
    title: I18n.t("No result were found."),
    text: I18n.t("Try again with different filters.")
  });
  return JsxRuntime.jsx(Scaffolded.make, {
    title: I18n.t("Top staffs"),
    state: state,
    dispatch: dispatch,
    columns: scaffoldedColumns,
    filters: filters,
    emptyState: emptyState,
    defaultQueryVariables: defaultQueryVariables
  });
}

let make = React.memo(AnalyticsTopPerformingStaffsPage);

export {
  Query,
  SortBy,
  Filters,
  Row,
  Scaffolded,
  scaffoldedColumns,
  initialDateRange,
  make,
}
/* query Not a pure module */
